export default "__VITE_ASSET__BTKjmNay__"